import { PERMISSIONS } from "@/constants";

export default [
    {
        name: "cohortAnalysis",
        meta: {
            title: "Cohort Analysis",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.ANALYTICS_ALL],
        },
        path: "/manage/cohortAnalysis",
        component: () => import("@/views/pages/cohortAnalysis/index.vue"),
    }
]